export {};
//# sourceMappingURL=inbound-envelope.js.map